import React from 'react';
import { Tooltip as ChakraTooltip } from '@chakra-ui/react';

const Tooltip = ({ label = ``, children, ...props }) => {
  return (
    <ChakraTooltip
      hasArrow
      label={label}
      p="0.5rem"
      bg="purple.600"
      color="white"
      borderRadius="0.125rem"
      placement="left"
      maxW="9.5rem"
      fontSize="sm"
      gutter="4"
      {...props}>
      {children}
    </ChakraTooltip>
  );
};

export default Tooltip;
